import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  options: { customProperties: true }, // allows to access theme color such as primary in css / scss
  theme: {
    themes: {
      light: {
        primary: '#22AFED'
      },
      dark: {
        primary: '#22AFED'
      }
    }
  }
})
